import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import hoistNonReactStatics from 'hoist-non-react-statics';
import requestLogin from '../actions/request-login';
import preventClickInDemoMode from './prevent-click-in-demo-mode';
import createHocName from '../services/create-hoc-name';
import withAuth from './with-auth';

const NAME = 'EnsureAuth';

export default function ensureAuth(WrappedComponent) {
  const ChildComponent = preventClickInDemoMode(WrappedComponent);

  class EnsureAuth extends Component {
    static displayName = createHocName(NAME, WrappedComponent);

    handleClick = event => {
      const { isAuthenticated, onClick, requestLogin } = this.props;
      if (isAuthenticated) {
        onClick && onClick(event);
      } else {
        event.preventDefault();
        event.stopPropagation();

        requestLogin().then(() => onClick && onClick(event));
      }
    };

    render() {
      const otherProps = _.omit(this.props, ['isAuthenticated', 'onClick', 'requestLogin']);
      return <ChildComponent {...otherProps} onClick={this.handleClick}/>;
    }
  }

  EnsureAuth.propTypes = {
    requestLogin: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
    onClick: PropTypes.func,
  };

  hoistNonReactStatics(EnsureAuth, ChildComponent);

  const mapDispatchToProps = dispatch =>
    bindActionCreators(
      {
        requestLogin,
      },
      dispatch
    );

  return connect(undefined, mapDispatchToProps)(withAuth(EnsureAuth));
}



// WEBPACK FOOTER //
// ./app/hoc/ensure-auth.js